export function createKioskSubmission({ patientId, queue, responses, signatures }) {
  const acknowledgedAt = new Date().toISOString();
  return JSON.parse(JSON.stringify({ operation_id:crypto.randomUUID(), patient_id:patientId,
    forms:queue.filter(item => item.type === 'form').map(item => {
      const signature = signatures[item.data.id];
      return { template_id:item.data.id, responses:{ ...(responses[item.data.id] || {}),
        ...(item.data.requires_signature && signature?.data ? {_esign_acknowledged_at:acknowledgedAt} : {}) },
        signature:signature?.data ? {data:signature.data, signer_name:signature.signer_name || '', signer_relationship:'self'} : null };
    }),
    outcomes:queue.filter(item => item.type === 'outcome').map(item => ({instrument_id:item.data.id, responses:responses[item.data.id] || {}}))
      .filter(item => Object.keys(item.responses).length > 0),
  }));
}
export function confirmKioskSubmission(data, operation) {
  if (data?.success !== true || data.operation_id !== operation.operation_id || data.patient_id !== operation.patient_id ||
      !Array.isArray(data.submissions) || !Array.isArray(data.administrations) ||
      data.submissions.length !== operation.forms.length || data.administrations.length !== operation.outcomes.length ||
      operation.forms.some(form => !data.submissions.some(row => row.id && row.form_template_id === form.template_id && row.patient_id === operation.patient_id)) ||
      operation.outcomes.some(outcome => !data.administrations.some(row => row.id && row.instrument_id === outcome.instrument_id && row.patient_id === operation.patient_id)))
    throw new Error('The complete submission receipt was not confirmed. Retry the same submission.');
  return data;
}
